module.exports = __webpack_public_path__ + "static/assets/767c777d267a9bc384c80f2dfbc9a6a5.png";